import Text from '@zenbusiness/zui/Text';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import PropTypes from 'prop-types';

import { AutocompleteStyled } from './styles';

export default function AutoCompleteInput({
  multiple,
  filterSelectedOptions,
  blurOnSelect,
  openOnFocus,
  disabled,
  onChange,
  getOptionLabel,
  renderInput,
  sx,
  renderOption,
  options,
  renderTags,
  popupIcon,
  ...otherProps
}) {
  const defaultRenderOption = (props, option, { inputValue }) => {
    // eslint-disable-next-line react/prop-types
    const { key, ...restProps } = props;
    const matches = match(option.toString(), inputValue, {
      insideWords: true,
      findAllOccurrences: true
    });
    const parts = parse(option.toString(), matches);

    return (
      <Text
        key={key}
        {...restProps}
      >
        <Text component="span">
          {parts.map((part, index) => (
            <Text
              component="span"
              // eslint-disable-next-line react/no-array-index-key
              key={`${part.text}-${index}`}
              size="lg"
              weight={part.highlight ? 'medium' : 'regular'}
            >
              {part.text}
            </Text>
          ))}
        </Text>
      </Text>
    );
  };

  return (
    <AutocompleteStyled
      blurOnSelect={blurOnSelect}
      disabled={disabled}
      filterSelectedOptions={filterSelectedOptions}
      getOptionLabel={getOptionLabel}
      multiple={multiple}
      onChange={onChange}
      openOnFocus={openOnFocus}
      options={options}
      popupIcon={popupIcon}
      renderInput={renderInput}
      renderOption={renderOption ?? defaultRenderOption}
      renderTags={renderTags}
      sx={sx}
      {...otherProps}
    />
  );
}

AutoCompleteInput.propTypes = {
  multiple: PropTypes.bool,
  filterSelectedOptions: PropTypes.bool,
  blurOnSelect: PropTypes.bool,
  openOnFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  getOptionLabel: PropTypes.func,
  renderInput: PropTypes.func,
  renderOption: PropTypes.func,
  renderTags: PropTypes.func,
  sx: PropTypes.shape({}),
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any,
  // eslint-disable-next-line react/forbid-prop-types
  options: PropTypes.arrayOf(PropTypes.any),
  popupIcon: PropTypes.node
};
